module.exports = __webpack_public_path__ + "media/images/icon__arrow-up-right-9eb5f9a964de4b5ccb4415f6e56c12e7.png";